import { render } from "./RightClickDeviceMenu.vue?vue&type=template&id=9f8c8f06&scoped=true"
import script from "./RightClickDeviceMenu.vue?vue&type=script&lang=js"
export * from "./RightClickDeviceMenu.vue?vue&type=script&lang=js"

import "./RightClickDeviceMenu.vue?vue&type=style&index=0&id=9f8c8f06&lang=stylus&scoped=true"

import exportComponent from "D:\\01.WorkData\\05.WebProjects\\04.SourceCode\\02.Vue\\project_110_008\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f8c8f06"]])

export default __exports__